import Image from "next/legacy/image";
import Link from "next/link";

import { urlFor } from "../../../src/cms-blog-api/sanity";
import { BasePost, Category } from "../../../src/types/blog";

type SideBarItemProps = {
  post?: BasePost;
  category?: Category;
};

export default function SideBarItem({ post, category }: SideBarItemProps) {
  return (
    <Link href={(post && `/blog/${post.slug}`) || (category && `/blog/categorias/${category.slug}`)} className="grid grid-cols-5 gap-x-3">
      <div>
        <div className="rounded-lg shadow-post-image relative aspect-w-1 aspect-h-1">
          <Image
            className="rounded-lg"
            src={urlFor((post && post.image) || (category && category.image)).url()}
            layout="fill"
            objectFit="cover"
            alt={(post && post.image.altText) || (category && category.image.altText)}
            placeholder="blur"
            blurDataURL={(post && post.image.asset.metadata.lqip) || (category && category.image.asset.metadata.lqip)}
            sizes="10vw"
          />
        </div>
      </div>
      <div className="col-span-4 flex flex-col justify-center">
        <p className="line-clamp-1">{(post && post.title) || (category && category.name)}</p>
        <p className="text-sm text-gray-500 line-clamp-1">{(post && post.summary) || (category && category.description)}</p>
      </div>
    </Link>
  );
}
